import { useEffect, useRef } from 'react';
import Banner from '../../Components/Layout/Banner/Banner.js';
import '../Location/Location.css';

function Location() {
    const mapRef = useRef(null);

    // 네이버 플레이스 실제 URL (등록된 온평 플레이스 주소로 교체하세요)
    const PLACE_URL = "https://map.naver.com/p/entry/place/2091815897?placePath=/home?entry=pll&from=map&fromPanelNum=1&additionalHeight=76&timestamp=202602191402&locale=ko&svcName=map_pcv5&searchType=place&lng=127.0090128&lat=37.4941732&c=15.00,0,0,0,dh";

    useEffect(() => {
        if (window.naver && window.naver.maps && mapRef.current) {
            const location = new window.naver.maps.LatLng(37.4941446173256, 127.008966289063);

            const mapOptions = {
                center: location,
                zoom: 17,
                zoomControl: true,
                zoomControlOptions: {
                    position: window.naver.maps.Position.TOP_RIGHT
                }
            };

            const map = new window.naver.maps.Map(mapRef.current, mapOptions);

            // 1. 마커 설정
            const marker = new window.naver.maps.Marker({
                position: location,
                map: map,
                title: '법률사무소 온평',
                animation: window.naver.maps.Animation.DROP // 마커가 떨어지는 효과
            });

            // 2. 정보창 설정 (마커 클릭 시 나타나는 창)
            const contentString = [
                '<div style="padding:10px; min-width:150px; line-height:150%; text-align:center;">',
                '   <h5 style="margin:0 0 5px 0; font-size:15px; font-weight:600; color:#D9B384;">법률사무소 온평</h5>',
                '   <a href="' + PLACE_URL + '" target="_blank" style="font-size:12px; color:black;">네이버 지도 보기</a>',
                '</div>'
            ].join('');

            const infowindow = new window.naver.maps.InfoWindow({
                content: contentString,
                borderWidth: 1,
                borderColor: "#D9B384",
                anchorSize: new window.naver.maps.Size(10, 10)
            });

            // 페이지 로드 시 정보창 바로 띄우기
            infowindow.open(map, marker);

            // 마커 클릭 시 네이버 플레이스로 이동
            window.naver.maps.Event.addListener(marker, "click", function () {
                window.open(PLACE_URL, "_blank");
            });
        }
    }, []);

    return (
        <>
            <Banner />
            <div className="py-5 container text-center">
                <h4 className="mb-4 fw-bold location-title">법률사무소 온평</h4>
                <p className="mb-2 fs-5">서울 서초구 서초대로45길 20 (서초동) 510호</p>
                <p className="mb-4 text-muted">서초역 7번 출구 / 교대역 10번 출구 인근</p>

                {/* 네이버 플레이스 직접 이동 버튼 */}
                <a
                    href={PLACE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn mb-4 px-4 py-2 shadow-sm"
                    style={{ backgroundColor: '#03C75A', color: '#fff', fontWeight: 'bold', borderRadius: '30px' }}
                >
                    네이버 지도로 길찾기
                </a>

                <div
                    ref={mapRef}
                    style={{
                        width: '100%',
                        height: '450px',
                        borderRadius: '15px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}
                    className="mx-auto border"
                ></div>
            </div>
        </>
    );
}

export default Location;